$(function() {
  const productInfoElement = $(".product .product-info");
  const productType = productInfoElement.data("product-type");
  const accordion = $(productInfoElement).find(".product-info__accordion");
  const buyButtons = $(productInfoElement).find(".product-info__buy-buttons");

  if (productType != "Video") return;
  if (accordion.length == 0 || buyButtons.length == 0) return;

  accordion.remove();
  accordion.insertBefore(buyButtons);
});